import { concatStyleSets, IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { Sizes } from '../../themes/styles';

export interface IBasicListStyles {
  root?: IStyle;
  item?: IStyle;
}

export const basicListStylesDefault: IBasicListStyles = {
  root: {
    position: 'relative',
    '&.horizontal': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  item: {
    position: 'relative',
  },
};

export const basicListStylesNowrap: IBasicListStyles = {
  root: {
    '&.horizontal': {
      flexWrap: 'nowrap',
    },
  },
};

export const basicListStylesDropdown: IBasicListStyles = {
  root: {
    paddingTop: 2,
    paddingBottom: 2,
    lineHeight: 23,
    maxHeight: 85, //3 lines
    overflow: 'auto',
  },
};

export const basicListStylesInput = (theme: IH2OTheme): IBasicListStyles =>
  concatStyleSets(basicListStylesDropdown, {
    root: {
      padding: '4px 16px',
      borderRadius: Sizes.borderRadius,
      border: `1px solid ${theme.semanticColors?.inputBorder}`,
      minHeight: 37,
    },
  });

export const basicListStylesSearch = (theme: IH2OTheme): IBasicListStyles => ({
  root: {
    paddingBottom: '8px',
    borderBottom: `1px solid ${theme.semanticColors?.inputBorder}`,
    '.h2o-BasicList-item': {
      marginTop: '8px',
    },
  },
});
